import { useMutation, useQueryClient } from "@tanstack/react-query";
import { partnerBusinessRepo } from "@/data/repos/partnerBusinessRepo";
import type { BusinessProfileInput } from "@/domain/business/schema";
import type { Business } from "@/domain/business/types";

export function useCreateBusiness() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: BusinessProfileInput) => partnerBusinessRepo.create(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["user-business"] }),
  });
}

export function useUpdateBusiness() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ business, input }: { business: Business; input: BusinessProfileInput }) =>
      partnerBusinessRepo.update(business, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["user-business"] }),
  });
}
